import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Overline } from "@/components/primitives";

export function ArticleCard({ article }) {
  const date = article.publication_date
    ? new Date(article.publication_date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    : "";
  return (
    <Link
      to={`/ideas/article/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group block bg-white border border-slate-200 hover:border-[#0F2C59] transition-colors duration-300"
    >
      {article.featured_image && (
        <div className="aspect-[16/10] overflow-hidden bg-slate-100">
          <img
            src={article.featured_image}
            alt={article.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </div>
      )}
      <div className="p-6">
        <Overline>{article.category}</Overline>
        <h3 className="font-serif-display text-xl font-semibold mt-3 leading-snug text-[#111827] group-hover:text-[#0F2C59] transition-colors">
          {article.title}
        </h3>
        <p className="text-slate-600 text-sm mt-3 leading-relaxed line-clamp-3">{article.excerpt}</p>
        <div className="flex items-center justify-between mt-5 text-xs text-slate-500">
          <span>{date}</span>
          <span className="inline-flex items-center gap-1"><Clock size={13} /> {article.reading_time} min</span>
        </div>
      </div>
    </Link>
  );
}

export function TopicCard({ topic, span = false }) {
  return (
    <Link
      to={`/ideas/${topic.slug}`}
      data-testid={`topic-card-${topic.slug}`}
      className={`group relative flex flex-col justify-between border border-slate-200 p-7 bg-white hover:border-[#0F2C59] hover:-translate-y-1 transition-all duration-300 ${span ? "sm:col-span-2" : ""}`}
    >
      <div>
        <h3 className="font-serif-display text-2xl font-semibold text-[#111827] group-hover:text-[#0F2C59] transition-colors">
          {topic.name}
        </h3>
        <p className="text-slate-600 text-sm mt-3 leading-relaxed">{topic.description}</p>
      </div>
      <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0F2C59]">
        Explore <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
      </span>
    </Link>
  );
}

export function PrincipleCard({ principle }) {
  return (
    <div data-testid={`principle-card-${principle.slug || principle.id}`} className="border-l-2 border-[#0F2C59] pl-6 py-2">
      <Overline>{principle.category}</Overline>
      <h3 className="font-serif-display text-xl font-semibold mt-2 text-[#111827]">{principle.title}</h3>
      <p className="font-serif-display italic text-lg text-slate-700 mt-3 leading-snug">"{principle.statement}"</p>
      {principle.explanation && <p className="text-slate-600 text-sm mt-3 leading-relaxed">{principle.explanation}</p>}
    </div>
  );
}
